import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetSuggestedContactsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetSuggestedContactsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getSuggestedContacts = (request: GetSuggestedContactsRequest, options?: CashRequestOptions) =>
  post<GetSuggestedContactsRequest, GetSuggestedContactsResponse>('/2.0/cash/get-suggested-contacts', request, {
    ...options,
    rejectOnError: true,
  })
